<template>
  <el-row :gutter="6">
    <el-col v-for="o in authors" :key="o.id" :md="cols" :lg="cols" :xl="cols">
      <div @click="nav(o.id)">
        <el-card :body-style="{ padding: '0px' }">
          <el-image
            style="width: 100%; height: 33vh"
            :src="o.image_url === null ? `default-author.png` : o.image_url"
            :fit="'cover'"
          >
            <div slot="placeholder">
              <el-image
                style="width: 100%; height: 33vh"
                src="@/assets/default-author.png"
                :fit="'cover'"
              >
              </el-image>
            </div>

            ></el-image
          >

          <div style="padding: 14px;cursor: pointer;">
            <div class="bottom clearfix">
              <el-button type="text" class="button">
                <i class="lg el-icon-link"></i> <span>{{ o.name }}</span>
              </el-button>
            </div>
          </div>
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import $HTTP from "../plugins/axios";
// import { mapMutations } from "vuex";
import nav from "../mixins/nav";
export default {
  components: {},
  props: {
    url: String,
    title: String,
    count: Number
  },
  data() {
    return {
      iAuthors: [],
      hover: false,
      snackbar: false,
      path: ""
    };
  },
  mixins: [nav],
  name: "authortop",
  computed: {
    authors() {
      return this.iAuthors.slice(0, this.count);
    },
    cols() {
      return this.url === "top" ? 6 : 12;
    }
  },
  methods: {
    async getProlificAuthors() {
      // const loading = this.$loading({
      //   lock: true,
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      this.iAuthors = (await $HTTP.get(`/author/${this.url}`)).data.authors;
      // loading.close();
    },
    share(id) {
      this.path = `author/` + id;
    },
    navTop(id) {
      // alert(id);
      this.nav(id);
    }
  },
  async created() {
    this.getProlificAuthors();
  }
};
</script>
<style scoped>
.el-card {
  margin-bottom: 16px;
}
</style>
